import { render, staticRenderFns } from "./CustomerEditReceiver.vue?vue&type=template&id=3b94ffea"
import script from "./CustomerEditReceiver.vue?vue&type=script&lang=js"
export * from "./CustomerEditReceiver.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditReceiver.vue?vue&type=style&index=0&id=3b94ffea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports